/**
 * Shared Call Status options, badge colors, and helper utilities.
 */

export const CALL_STATUS_OPTIONS = [
  "Confirmed",
  "Rescheduled",
  "KOR (Keeps on ringing)",
  "CBR (Cannot be reached)",
  "Cancelled",
  "Unattended",
  "Busy tone",
];

export const CALL_STATUS_OTHERS = "Others...";

export const CALL_STATUS_COLORS = {
  "Confirmed":                "bg-yellow-100 text-yellow-800",
  "Rescheduled":              "bg-blue-100 text-blue-800",
  "KOR (Keeps on ringing)":   "bg-orange-100 text-orange-800",
  "CBR (Cannot be reached)":  "bg-gray-200 text-gray-700",
  "Cancelled":                "bg-red-100 text-red-700",
  "Unattended":               "bg-slate-100 text-slate-700",
  "Busy tone":                "bg-amber-100 text-amber-800",
};

/** Fallback badge style for custom / legacy / "Others" values */
export const CALL_STATUS_DEFAULT_COLOR = "bg-purple-100 text-purple-800";

/**
 * Get the badge color classes for a call_status value.
 * Returns the mapped color for known statuses, or the default for custom values.
 */
export function getCallStatusColor(value) {
  if (!value) return "";
  return CALL_STATUS_COLORS[value] || CALL_STATUS_DEFAULT_COLOR;
}

/**
 * Determine whether a stored call_status value is a known standard option.
 */
export function isStandardCallStatus(value) {
  return CALL_STATUS_OPTIONS.includes(value);
}
